var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-x",
    d: "M0.626859 0.654189C1.02836 0.252466 1.57283 0.0267896 2.14055 0.0267896C2.70827 0.0267896 3.25275 0.252466 3.65425 0.654189L14.9866 11.9963L26.319 0.654189C26.5165 0.449525 26.7527 0.286277 27.0139 0.173972C27.2752 0.0616668 27.5561 0.00255337 27.8404 8.0908e-05C28.1247 -0.00239156 28.4066 0.0518259 28.6697 0.159571C28.9328 0.267315 29.1719 0.426429 29.3729 0.627628C29.5739 0.828827 29.7329 1.06808 29.8406 1.33143C29.9482 1.59478 30.0024 1.87695 29.9999 2.16148C29.9974 2.446 29.9384 2.72719 29.8262 2.98863C29.714 3.25006 29.5509 3.48652 29.3464 3.68419L18.014 15.0263L29.3464 26.3685C29.7364 26.7726 29.9522 27.3139 29.9473 27.8758C29.9424 28.4376 29.7173 28.9751 29.3203 29.3724C28.9233 29.7697 28.3863 29.995 27.825 29.9999C27.2636 30.0048 26.7228 29.7888 26.319 29.3985L14.9866 18.0563L3.65425 29.3985C3.25045 29.7888 2.70962 30.0048 2.14826 29.9999C1.58689 29.995 1.0499 29.7697 0.652939 29.3724C0.255979 28.9751 0.0308103 28.4376 0.0259322 27.8758C0.0210541 27.3139 0.236857 26.7726 0.626859 26.3685L11.9592 15.0263L0.626859 3.68419C0.225482 3.28234 0 2.7374 0 2.16919C0 1.60098 0.225482 1.05603 0.626859 0.654189Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1bb60e55be48dafb5f8bff600a3bffaa.svg";
export { ForwardRef as ReactComponent };